// Shipments table headers
export const shipmentsTableHead = [
  {
    id: 'no',
    numeric: true,
    label: 'No',
  },
  {
    id: 'fullName',
    numeric: true,
    label: 'Name',
  },
  {
    id: 'phoneNumber',
    numeric: true,
    label: 'Phone',
  },
  {
    id: 'shippingNo',
    numeric: true,
    label: 'Shipping No',
  },
  {
    id: 'brand',
    numeric: true,
    label: 'Brand',
  },
  {
    id: 'warehouseAddress',
    numeric: true,
    label: 'Warehouse',
  },
  {
    id: 'weight',
    numeric: true,
    label: 'Weight',
  },
  {
    id: 'state',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'CreatedAt',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

// Initial error state
export const initialErrors = {
  title: null,
  description: null,
  phoneNumber: null,
  address: null,
  brand: null,
  shipping: null,
  weight: null,
  dimensions: null,
};

// Shipment status list
export const shipmentStatusList = [
  { label: "Pending", value: "Pending", color: "#ff9800" },
  { label: "Received", value: "Received", color: "#0099DD" },
  { label: "In Shipping", value: "In Shipping", color: "#13AE92" },
  { label: "In Dispatch IQ", value: "In Dispatch IQ", color: "#13AE92" },
  { label: "In Delivery", value: "In Delivery", color: "#B24C6D" },
  { label: "Delivered", value: "Delivered", color: "#4CAF50" },
  { label: "Completed", value: "Completed", color: "#4CAF50" },
  { label: "Rejected", value: "Rejected", color: "#f44336" },
];

export const shipmentUnits = ["lbs", "kg"]

export const shipmentCurrency = ["IQD", "USD", "TRY", "KWD", "AED", "SR"]